import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrSetTermStatusPayload } from 'api/actions/hr-set-term-status/hr-set-term-status-payload';
import { HrSetTermStatusPathParameters } from 'api/actions/hr-set-term-status/hr-set-term-status-path-parameters';
import { HrSetTermStatusResponse } from 'api/actions/hr-set-term-status/hr-set-term-status-response';

type HrSetTermStatusQueryParameters = Record<string, any>;

/**
 * The path of the HrSetTermStatus action.
 */
export const hrSetTermStatusActionPath = new SweetPath<keyof HrSetTermStatusPathParameters>(
  '/api/hr/terms/{termId}/status',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrSetTermStatus actions.
 */
export default function createHrSetTermStatusAction(axios: AxiosInstance) {
  return function hrSetTermStatusAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrSetTermStatusPathParameters;
    query?: HrSetTermStatusQueryParameters;
    payload: HrSetTermStatusPayload;
  }) {
    const path = hrSetTermStatusActionPath.insert(parameters);

    return axios.request<HrSetTermStatusResponse, HrSetTermStatusResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
